export enum TooltipSize {
  wrap = 'wrap',
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l',
}
